var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"my-5",attrs:{"fluid":"md"}},[_c('action-widget'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }